import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useHistoryStore } from '@/lib/store/history-store';
import { useDeepSearchListener } from '@/lib/hooks/useDeepSearchListener';
import { AnalyzingState } from '@/components/search/analyzing-state';
import type { SearchType } from '@/lib/types';

export default function AnalyzingPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { userId, getSearch } = useHistoryStore();
  const [error, setError] = useState<string | null>(null);

  const searchId = searchParams.get('id');
  const type = searchParams.get('type') as SearchType;

  // Set up real-time listener for this search
  useDeepSearchListener(userId, searchId || '');

  // Get current search state from store
  const search = searchId ? getSearch(searchId) : null;

  useEffect(() => {
    document.title = 'Analyzing - Deepcheck';
  }, []);

  // Navigate to results when completed
  useEffect(() => {
    if (!search || !searchId) return;

    if (search.status === 'completed') {
      const routes: Record<string, string> = {
        'search-anything': `/search/anything/result?id=${searchId}`,
        'search-by-photo': `/search/photo/result?id=${searchId}`,
        'person-search': `/search/person/result?id=${searchId}`,
      };

      const route = routes[type];
      if (route) {
        navigate(route);
      }
    }

    if (search.status === 'failed') {
      setError(search.error?.message || 'Research failed');
    }
  }, [search?.status, searchId, type, navigate, search]);

  const handleComeBackLater = () => {
    navigate('/history-settings');
  };

  return (
    <main className="px-4 py-6">
      <AnalyzingState
        progress={search?.progress || 0}
        error={error}
        onComeBackLater={handleComeBackLater}
      />
    </main>
  );
}
